import script from "./UploadVideoCaptionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadVideoCaptionModal.vue?vue&type=script&setup=true&lang=js"

import "./UploadVideoCaptionModal.vue?vue&type=style&index=0&id=423c72f2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-423c72f2"]])

export default __exports__